// extracted by mini-css-extract-plugin
export default {"wrap":"tK-z","heading":"uK-z"};